export default __webpack_public_path__ + "static/media/arrowPrevDisabled.33b5eb1d.svg";